import React from 'react';
import '../styles/hotelAmenities.css';

const HotelAmenities = ({ language }) => {
  const amenities = [
    {
      icon: 'fas fa-wifi',
      title: { en: 'Free Wi-Fi', am: 'ነፃ ዋይ-ፋይ' },
      description: { 
        en: 'High-speed internet throughout the hotel',
        am: 'በሆቴሉ ውስጥ ሁሉ ፈጣን ኢንተርኔት'
      }
    },
    {
      icon: 'fas fa-concierge-bell',
      title: { en: '24/7 Front Desk', am: '24/7 የፊት ዴስክ' },
      description: { 
        en: 'Round-the-clock assistance and service',
        am: 'በሙሉ ሰዓት የእርዳታ እና አገልግሎት'
      }
    },
    {
      icon: 'fas fa-utensils',
      title: { en: 'Restaurant & Bar', am: 'ሬስቶራንት እና ባር' },
      description: { 
        en: 'Fine dining with local and international cuisine',
        am: 'የአካባቢ እና ዓለም አቀፍ ምግቦች ጋር ጥሩ ምግብ'
      }
    },


    {
      icon: 'fas fa-briefcase',
      title: { en: 'Business Center', am: 'የንግድ ማእከል' },
      description: { 
        en: 'Meeting rooms and business facilities',
        am: 'የስብሰባ ክፍሎች እና የንግድ መሳሪያዎች'
      }
    }
  ];

  return (
    <section className="hotel-amenities py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="amenities-title">
            {language === 'en' ? 'Hotel Amenities' : 'የሆቴል መሳሪያዎች'}
          </h2>
          <div className="amenities-title-underline mx-auto"></div>
          <p className="amenities-subtitle mt-3">
            {language === 'en' 
              ? 'Everything you need for a comfortable and memorable stay'
              : 'ለምቹ እና የማይረሳ መኖሪያ የሚያስፈልግዎ ሁሉ'
            }
          </p>
        </div>

        <div className="row">
          {amenities.map((amenity, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div className="amenity-card text-center">
                <div className="amenity-icon">
                  <i className={amenity.icon}></i>
                </div>
                <h5 className="amenity-title">{amenity.title[language]}</h5>
                <p className="amenity-description">{amenity.description[language]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HotelAmenities;
